<template>
  <article id="basculas"  >
    <div class="container">
      <h1>BASCULAS Y SOLUCIONES</h1>
      Control de pesadas de sus balanzas:
      Beneficios de su implementación:
      <ul>
      <li>Permite responder a las exigencias de los clientes</li>
      <li>Aumenta la eficiencia en la producción, reduciendo costos</li>
      <li>Disminuye reclamos y devoluciones</li>
      </ul>
      <h3>Revisión y diagnóstico:</h3>
      Determinando si el instrumento de pesaje funciona correctamente o presenta alguna desviación en el
      peso. Detectando las causas que provocan la falla y origen del error. A partir de este servicio, podremos
      determinar si la balanza requiere mantenimiento o reparación. Gestionando en representación de
      nuestro cliente, repuestos o insumos que son necesarios para la normalización del funcionamiento del
      instrumento de pesaje.
      <h3>Mantenimiento preventivo:</h3>
      Consiste en la revisión periódica y corrección oportuna de fallas, que puedan presentar un riesgo
      potencial para la balanza, esto es para garantizar el buen funcionamiento
      Con lo que obtendrá beneficios como:
        <li>Deteccion de posibles errores en el proceso productivo de su empresa por desviaciones en el peso de la balanza.</li>
        <li>Bajo costo en relación con el mantenimiento correctivo</li>
        <li>Reducción importante del riesgo por fallas</li>
        <li>Reduce la probabilidad de fallas inesperadas</li>
        <li>Permite llevar una mejor planificación de su trabajo</li>
      <h2>VENTAS DE BALANZAS DE DISTINTAS MARCAS Y ESPECIFICACIONES</h2>
      Asesoramos a nuestros clientes en funcion de sus necesidades operativas, cual es el instrumento de
      pesaje que se ajusta a sus necesidades.
    </div>
    
  </article>
  
</template>

<script>
export default {
  
  
}
</script>


<style>
  #basculas{
    background-image: url('/img/basculas-bg.jpg');
    color: #FEFEFE;
  }
</style>